/** Hubs and posts of the four content sections; each section name is localized. */
const guides = {
  en: "/guides",
  hu: "/utmutatok",
  pl: "/poradniki",
  es: "/guias",
  de: "/anleitungen",
  fr: "/guides",
  pt: "/guias",
  ja: "/gaido",
  ko: "/gaideu",
  it: "/guide",
  nl: "/handleidingen",
  ru: "/rukovodstva",
  ar: "/adilla",
  hi: "/margdarshan",
  zh: "/zhinan",
  id: "/panduan",
  tr: "/rehberler",
};

const scenarios = {
  en: "/scenarios",
  hu: "/esetek",
  pl: "/scenariusze",
  es: "/escenarios",
  de: "/szenarien",
  fr: "/scenarios",
  pt: "/cenarios",
  ja: "/shinario",
  ko: "/sinario",
  it: "/scenari",
  nl: "/scenarios",
  ru: "/scenarii",
  ar: "/sinariyuhat",
  hi: "/paridrishya",
  zh: "/changjing",
  id: "/skenario",
  tr: "/senaryolar",
};

const comparisons = {
  en: "/comparisons",
  hu: "/osszehasonlitasok",
  pl: "/porownania",
  es: "/comparativas",
  de: "/vergleiche",
  fr: "/comparatifs",
  pt: "/comparacoes",
  ja: "/hikaku",
  ko: "/bigyo",
  it: "/confronti",
  nl: "/vergelijkingen",
  ru: "/sravneniya",
  ar: "/muqaranat",
  hi: "/tulna",
  zh: "/duibi",
  id: "/perbandingan",
  tr: "/karsilastirmalar",
};

const articles = {
  en: "/articles",
  hu: "/cikkek",
  pl: "/artykuly",
  es: "/articulos",
  de: "/artikel",
  fr: "/articles",
  pt: "/artigos",
  ja: "/kiji",
  ko: "/gisa",
  it: "/articoli",
  nl: "/artikelen",
  ru: "/stati",
  ar: "/maqalat",
  hi: "/lekh",
  zh: "/wenzhang",
  id: "/artikel",
  tr: "/makaleler",
};

function withSlug<T extends Record<string, string>>(
  hub: T,
): { [K in keyof T]: string } {
  return Object.fromEntries(
    Object.entries(hub).map(([locale, path]) => [locale, `${path}/[slug]`]),
  ) as { [K in keyof T]: string };
}

export const contentPathnames = {
  "/guides": guides,
  "/guides/[slug]": withSlug(guides),
  "/scenarios": scenarios,
  "/scenarios/[slug]": withSlug(scenarios),
  "/comparisons": comparisons,
  "/comparisons/[slug]": withSlug(comparisons),
  "/articles": articles,
  "/articles/[slug]": withSlug(articles),
};
